import axios from "@/api/axios"

class Device {
  constructor() {
    this.numpad = false
    this.directional = true
    this.isSTB = true
    this._volumeRange = 25
    this.remoteState = null
    this._interval = 10000
  }
  async _init() {
    _$.vue.$on("bluetooth", () => this._checkRemoteState())
    window.setInterval(() => this._checkRemoteState(), this._interval)
    return true
  }

  async properties() {
    const { macAddress, ipAddress, firmwareVersion, appVersion, brand, model } = await __._api.getProperties()

    const properties = {
      mac: macAddress,
      ip: ipAddress,
      serial: "15975300",
      firmware: firmwareVersion,
      software: appVersion,
      manufacturer: brand.includes("HAKO") ? "Playmore" : brand.toUpperCase(),
      product: model.includes("HAKO") ? "PRMSTB-102" : model,
      type: "playmoreatv"
    }

    const res = Object.keys(properties).every(key => {
      return properties[key] || false
    })

    if (["ARCELIK", "ARGUEST", "BEKO", "GRUNDIG", "ONVO", "TCL"].includes(properties.manufacturer)) {
      this.isSTB = false
      this._volumeRange = 100
    }

    return res && properties
  }
  async baseUrl() {
    try {
      return JSON.parse(playmore.platform.getConfigAll("private")).url
    } catch (error) {
      return location.origin
    }
  }
  async getKeyMap() {
    return [
      // Controllers
      [21, "left"],
      [19, "up"],
      [22, "right"],
      [20, "down"],
      [23, "enter"],
      [4, "back"],
      [3, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [-1, "play"],
      [-1, "pause"],
      [85, "toggle"],
      [-1, "stop"],
      [90, "fw"],
      [89, "rw"],
      [88, "prev"],
      [87, "next"],

      // TV
      //[92, "ch_up"],
      //[93, "ch_down"],
      [166, "ch_up"],
      [167, "ch_down"],
      [131, "tv"], //Register
      [-1, "subtitle"], //Register
      [-1, "list"], //Register
      [-1, "epg"],
      [136, "switch"],
      [133, "favorite"],

      // General
      [132, "info"],
      [186, "settings"], //Register
      [-1, "alarm-clock"],
      [-1, "sleep-timer"],
      [-1, "source"], //Register
      [-1, "power"],
      [-1, "home"], //Register
      [-1, "refresh"], //Register

      [142, "red"],
      [141, "green"],
      [140, "yellow"],
      [139, "blue"],

      // Numpad
      [7, "numpad", 0],
      [8, "numpad", 1],
      [9, "numpad", 2],
      [10, "numpad", 3],
      [11, "numpad", 4],
      [12, "numpad", 5],
      [13, "numpad", 6],
      [14, "numpad", 7],
      [15, "numpad", 8],
      [16, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [134, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [64, "browser"],
      [-1, "cast"],
      [209, "movies"],
      [-1, "musics"],
      [-1, "usb"],
      [135, "shahid"]
    ]
  }
  async setName(name, adb = false) {
    if (!name) return false

    if (!adb) return playmore.device.setDeviceName(name)
    return __.api.adb.send({
      device: __.device.properties.ip,
      command: "name",
      params: {
        name: name
      }
    })
  }
  async getName() {
    return playmore.device.getDeviceName()
  }

  /* Register Methods */
  async registerKeys() {
    return true
  }

  /* Volume Management */
  async volume(volume) {
    if (typeof volume !== "number") {
      const level = playmore.device.volume()
      return Math.round((level * 100) / this._volumeRange)
    } else {
      return playmore.device.volume(Math.round((this._volumeRange * volume) / 100))
    }
  }
  async mute(value) {
    if (["boolean", "number"].indexOf(typeof value) >= 0) return playmore.device.mute(_$.true(value))
    return playmore.device.mute()
  }
  async maxVolume() {
    _$.vue.$on("volumeChanged", event => {
      if (event.detail > __.device.maxVolume) __.device.volume(__.device.maxVolume)
    })
    return true
  }

  /* Power Management */
  async getPowerState() {
    return "on"
  }
  async powerOn() {
    return true
  }
  async standBy() {
    return true
  }
  async reboot() {
    playmore.platform.setConfig("rebootByDevice", true)
    setTimeout(() => playmore.device.reboot(), 2000)
    return true
  }
  async clearData() {
    let isNative = false
    const { type, manufacturer } = __.device.properties
    if (["ARCELIK", "ARGUEST", "BEKO", "GRUNDIG"].includes(manufacturer) && type === "playmoreatv") isNative = true
    else if (__._device.isSTB) isNative = true

    if (isNative) {
      const promise = await _$.progress.create()

      /* Library Code */
      playmore.platform.returnToPlatform()
      await _$.sleep(1500)
      playmore.device.clearAppData()
      /* Library Code */

      _$.sleep(3000).then(() => promise.resolve())

      return promise.done
    } else {
      return __.api.adb.send({
        device: __.device.properties.ip,
        command: "clear",
        params: {
          packages: __.app.availableApps.map(item => item.key).filter(item => !item.includes("com.playroomtv.playroomstb"))
        }
      })
    }
  }

  /* Soft AP */
  async getSoftAP() {
    const { password, ssid, status } = JSON.parse(playmore.device.getSoftAP())

    return {
      ssid: ssid,
      password: password,
      status: _$.true(status)
    }
  }
  async enableSoftAP() {
    playmore.device.enableSoftAP()
    await _$.sleep(1000)
    return true
  }
  async disableSoftAP() {
    playmore.device.disableSoftAP()
    await _$.sleep(1000)
    return true
  }
  async isSoftAPEnabled() {
    return playmore.device.isEnabledSoftAP()
  }
  _checkRemoteState() {
    const state = this._getRemoteState()
    if (JSON.stringify(this.remoteState) === JSON.stringify(state)) return

    this.remoteState = state
    const locationNumber = __.device.get("location")

    axios()
      .post("/api/send/remoteState", { mac: __.device.properties.mac, location: locationNumber, state: JSON.stringify(state) })
      .catch(err => _$.error(err))

    return true
  }
  _getRemoteState() {
    try {
      const device = JSON.parse(playmore.device.getBluetoothDevices())
        .devices.filter(item => item.name === "RemoteG10")
        .pop()

      const { connected: status, batteryLevel: battery } = device

      return { status, battery }
    } catch (error) {
      return { status: false, battery: 0 }
    }
  }
}

export default Device
